import { Component, EventEmitter, Inject, Input, OnInit, Output, OnDestroy, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ProcessStateService, TaxReturnService } from "../../../../../../swaggerServices";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CurrentBatchService } from "../../../../services/current-batch.service";
import { TenantConfigService } from "../../../../services/tenant-config.service";
import { ConfigStateService } from "../../../../../app/config/config-state.service";

@Component({
    selector: "batch-generate-package",
    templateUrl: "./batch-generate-package.component.html",
    styleUrls: ["./batch-generate-package.component.scss"],
    standalone: false
})
export class BatchGeneratePackage implements OnInit, OnDestroy {
  @Input() selectedTaxReturns;
  @Input() currentBatchList;
  @Input() batchId;
  @Input() clientId;
  @Input() taxReturnAlias: string;
  @Input() year;
  @Input() genType;
  @Output() completed = new EventEmitter();
  showModal = true;
  responseData = [];
  batchActionState: "OPENED" | "LOADING" | "COMPLETED" = null;
  errorMessage = "";
  warnings = 0;
  runningTasksList: any[];
  queuedTasksList: any[];

  private unsubscribe: Subject<void> = new Subject();
  constructor(
    private taxReturnService: TaxReturnService,
    private currentBatchService: CurrentBatchService,
    private  processStateService: ProcessStateService,
    @Optional() private dialogRef?: MatDialogRef<BatchGeneratePackage>,
    @Optional() @Inject(MAT_DIALOG_DATA) data?: Partial<BatchGeneratePackage>) {
    Object.assign(this, data);
  }

  get selectedTaxReturnIds() {
    return this.selectedTaxReturns ? Object.keys(this.selectedTaxReturns).map(n => Number(n)) : [];
  }

  get submitButtonDisabled() {
    return !this.batchId || this.batchActionState === 'LOADING' || this.warnings;
  }

  ngOnInit() {
    this.batchActionState = 'OPENED';
    this.errorMessage = '';
    if (!this.batchId) {
      this.errorMessage = 'This action can only be applied to a batch. Select a batch and try again.';
      return;
    }
    this.currentBatchService.warningsObservable.subscribe(result => {
      if (result.count && this.genType !== 'DRAFT') {
        this.warnings = result.count;
        this.errorMessage = `Please fix the ${this.warnings} warning/s before finalising package`;
        return;
      } else if (result.count === null && this.genType !== 'DRAFT') {
        this.errorMessage = 'Please wait for the warnings count to have a value before triggering this process'
        return;
      }
    });
    this.updateTaskLists();
  }

  updateTaskLists() {
    this.processStateService.getBulkEntityProcessState(`generate_${this.year}_%`, 'client', this.clientId).subscribe(result => {
      const runningTasks = result.filter(r => r.state === 'R');
      const queuedTasks = result.filter(r => r.state === 'Q');

      this.runningTasksList = [...runningTasks.map((val) => {
        return this.currentBatchList.find(b => Number(val.process.replace(`generate_${this.year}_`, '')) === b.id).name
      })];
      this.queuedTasksList = [...queuedTasks.map((val) => {
        return this.currentBatchList.find(b => Number(val.process.replace(`generate_${this.year}_`, '')) === b.id).name
      })];
    })
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  batchGenerate() {
    this.errorMessage = '';
    this.batchActionState = 'LOADING';
    this.taxReturnService.schedulePackageGeneration({
      taxReturnIds: this.selectedTaxReturnIds,
      batchId: parseInt(this.batchId),
      clientId: parseInt(this.clientId),
      taxYear: parseInt(this.year),
      generationType: this.genType,
    })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(resp => {
        this.batchActionState = 'COMPLETED';
        this.updateTaskLists();
      }, error => {
        this.errorMessage = "Something went wrong, please try again later.";
        this.batchActionState = 'OPENED';
        return;
      });
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.showModal = false;
    this.completed.emit();
  }

}
